import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { Calendar } from 'lucide-react';
import { cn } from '../../../../../lib/utils';

function DateRangePicker({ startDate, endDate, onChange }) {
  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-muted/50">
        <Calendar className="h-4 w-4 text-muted-foreground" />
        <DatePicker.RangePicker
          onChange={(data) => {
            if (data) {
              const [start, end] = data;
              onChange(start, end);
            }
          }}
          defaultValue={[startDate, endDate]}
          className={cn(
            'border-0 bg-transparent shadow-none',
            '[&_.ant-picker-input>input]:text-foreground',
            '[&_.ant-picker-suffix]:text-muted-foreground',
            '[&_.ant-picker-separator]:text-muted-foreground',
            '[&_.ant-picker-clear]:text-muted-foreground',
          )}
          style={{ background: 'transparent' }}
        />
      </div>
    </div>
  );
}

DateRangePicker.propTypes = {
  startDate: PropTypes.instanceOf(dayjs).isRequired,
  endDate: PropTypes.instanceOf(dayjs).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DateRangePicker;
